import axios from 'axios';

import { API_URL } from './constantes';

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.defaults.withCredentials = true;

function setupInterceptors(instance: typeof axios | any) {
  if (!instance.interceptors) return;

  instance.interceptors.request.use(
    config => {
      console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
      return config;
    },
    error => {
      console.error('API Request Error:', error);
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      console.error('API Response Error:', error.response?.data || error.message);
      return Promise.reject(error);
    },
  );
}

setupInterceptors(apiClient);

export default apiClient;
